import GLightbox from "glightbox";

$(function () {
  if (document.querySelector(".news-details-carousel a.glightbox")) {
    GLightbox({
      selector: ".news-details-carousel a.glightbox",
      openEffect: "none",
      closeEffect: "none",
      slideEffect: "none",
    });
  }
});
